import { render, staticRenderFns } from "./StepSectionHeader.vue?vue&type=template&id=03a1bb53&scoped=true"
import script from "./StepSectionHeader.vue?vue&type=script&lang=ts"
export * from "./StepSectionHeader.vue?vue&type=script&lang=ts"
import style0 from "./StepSectionHeader.vue?vue&type=style&index=0&id=03a1bb53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a1bb53",
  null
  
)

export default component.exports